function getParams(str) {
    var params = {};
    if (!!str && !!str.trim()) {
        var queryString = str.trim();
        queryString = queryString.replace(/.*?\?/, "").trim();

        if (!!queryString) {
            var keyValPairs = queryString.split('&');

            for (var pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split('=')[0];
                if (!key.length) continue;
                if (typeof params[key] === 'undefined')
                    params[key] = [];
                params[key].push(keyValPairs[pairNum].split('=')[1]);
            }
        }
    }
    return params;
};

function prepareIframeSrcUrl(videoUrl) {
    //youtube regex transform
    videoUrl = videoUrl.replace(/youtu\.be/i, "www.youtube.com/embed");
    var youtubeRegexp = /(.*youtube\.com)\/(?!embed)/i;
    var ytMatch = youtubeRegexp.exec(videoUrl);

    if (videoUrl.search(youtubeRegexp) !== -1) {
        var params = getParams(videoUrl);
        videoUrl = ytMatch[1].concat("/embed/").concat(params["v"]);
    } else {
        //media space url transform
        var regExp = /^(.*pwc\.mediaspace\.kaltura\.com)\/media(\/t)?\/(.*)/i;
        if (videoUrl.search(regExp) !== -1) {
            var match = regExp.exec(videoUrl);
            var videoId;
            var index = match[3].indexOf("/");
            if (index > 0) {
                videoId = match[3].substring(0, index);
            } else {
                videoId = match[3];
            }
            videoUrl = match[1].concat("/embed/secure/iframe/entryId/").concat(videoId);
        }
    }
    return videoUrl;
};

function playVideoFromUrl(videoUrl) {
   
    //youtube regex transform
    var iframe = jQuery('<iframe width="100%" height="100%" frameborder="0" allowFullScreen></iframe>').attr('src', videoUrl.replace("script",""));

    var windowDiv = jQuery('<div></div>');
    var wrapperDiv = jQuery('<div class="popout-nav video"></div>');

    windowDiv.append(wrapperDiv);
    wrapperDiv.append(iframe);

    var modalWindow = windowDiv.kendoWindow({
        modal: true,
        pinned: true,
        actions: ['Close'],
        width: "960",
        height: "540",
        visible: false,
        title: "Video",
        close: function () {
            modalWindow.destroy();
        }
    }).data('kendoWindow');

    modalWindow.center();
    modalWindow.open();
};

function playVideoFromKaltura(videoUrl, ksID) {

    //youtube regex transform
    var iframe = jQuery('<iframe id="kalturaIframe" data-kalturasessionid="' + ksID + '" width="100%" height="100%" frameborder="0" allowFullScreen></iframe>').attr('src', videoUrl.replace("script", ""));
    
    var modalWindow = jQuery('#kalturaVideoModal').kendoWindow({
        modal: true,
        pinned: true,
        actions: ['Close'],
        width: "960",
        height: "540",
        visible: false,
        title: "Video",
        open: function () {
            if (jQuery("#_video_player").find("[aria-label='Play']").length > 0) {
                var pauseIcons = jQuery(".playkit-icon.playkit-icon-pause");
                for (var i = 0; i < pauseIcons.length; i++) {
                    jQuery(".playkit-icon.playkit-icon-pause")[i].click();
                }
            }
        },
        close: function () {

            //Pause only if a video is playing
            if (jQuery("#_video_player").find("[aria-label='Pause']").length > 0) {
                var pauseIcons = jQuery(".playkit-icon.playkit-icon-pause");
                for (var i = 0; i < pauseIcons.length; i++) {
                    jQuery(".playkit-icon.playkit-icon-pause")[i].click();
                }
            }
        }
    }).data('kendoWindow');

    modalWindow.center();
    modalWindow.open();
};

function playVideo(videoUrl) {
    var isPoD = new RegExp("policyondemand").test(videoUrl);
    if (isPoD) {
        window.open(videoUrl);
        return;
    }

    //youtube regex transform
    var isPoD = new RegExp("policyondemand").test(videoUrl);
    if (isPoD) {
        window.open(videoUrl);
        return;
    }

    var url = prepareIframeSrcUrl(videoUrl);
    playVideoFromUrl(url);
};

function playKalturaVideo(videoUrl, ksID) {
    var isPoD = new RegExp("policyondemand").test(videoUrl);
    if (isPoD) {
        window.open(videoUrl);
        return;
    }

    //youtube regex transform
    var isPoD = new RegExp("policyondemand").test(videoUrl);
    if (isPoD) {
        window.open(videoUrl);
        return;
    }

    var url = prepareIframeSrcUrl(videoUrl);
    playVideoFromKaltura(url, ksID);
};
